module.exports = __webpack_public_path__ + "img/weibo.a7d24a05.png";